export default "__VITE_ASSET__CtGxEssu__"